module.exports = __webpack_public_path__ + "static/Burst1Mob-69bf989f1423d1c0d0d836d0c44198e0.jpg";